<template>
  <div>
    <a-transfer
      :data-source="mockData"
      :target-keys="targetKeys"
      :disabled="disabled"
      :filter-option="filterHandle"
      :show-search="showSearch"
      :show-select-all="false"
      @change="onChange"
      @search="search"
    >
      <template
        #children="{
          direction,
          filteredItems,
          selectedKeys,
          disabled: listDisabled,
          onItemSelectAll,
          onItemSelect,
        }"
      >
        <a-table
          :pagination="direction === 'left' ? pagination : {}"
          :row-selection="
            getRowSelection({
              selectedKeys,
              onItemSelectAll,
              onItemSelect,
            })
          "
           @change="handleTableChange"
          :columns="direction === 'left' ? leftColumns : rightColumns"
          :data-source="filteredItems"
          size="small"
          :style="{ pointerEvents: listDisabled ? 'none' : null }"
          :custom-row="
            ({ key, disabled: itemDisabled }) => ({
              onClick: () => {
                if (itemDisabled || listDisabled) return;
                onItemSelect(key, !selectedKeys.includes(key));
              },
            })
          "
        />
      </template>
    </a-transfer>
  </div>
</template>
<script>
import { difference } from 'lodash-es';
import { computed, defineComponent, ref } from 'vue';
import {getstoreWipedList} from "@/api/store";
const leftTableColumns = [
  {
    dataIndex: 'store_id',
    title: '门店ID',
  },
  {
    dataIndex: 'store_name',
    title: '门店名称',
  },
];
const rightTableColumns = [
  {
    dataIndex: 'store_name',
    title: '门店名称',
  },
];
export default defineComponent({
  setup(props,{emit}) {
        const targetKeys = ref([]);
    const current=ref(1)
    const total=ref(0)
    var mockData = ref([]);
    const getList=async (values)=>{
      let result=await getstoreWipedList(values).then(res=>res.data).catch(error=>error)
      if(mockData.value.length){
        var obj={}
        mockData.value=mockData.value.concat(result.data.data.map(v=>{return{key:v.store_id,title:v.store_name,store_id:v.store_id,store_name:v.store_name}}) 
        || []).reduce((cur,next) => {
              obj[next.key] ? "" : obj[next.key] = true && cur.push(next);
              return cur;
          },[])
      }else{
        mockData.value=result.data.data.map(v=>{return{key:v.store_id,title:v.store_name,store_id:v.store_id,store_name:v.store_name}}) || []
      }
      total.value=result.data.total
      current.value=result.data.current_page || 1
    }
    getList({page:1,limit:10})
    // const originTargetKeys = mockData.value.map(item => item.key);
    const disabled = ref(false);
    const showSearch = ref(true);
    const leftColumns = ref(leftTableColumns);
    const rightColumns = ref(rightTableColumns);

    const onChange = nextTargetKeys => {
      targetKeys.value = nextTargetKeys;
      // total.value=total.value-targetKeys.value.length
      emit('change',targetKeys.value)
    };
    const getRowSelection = ({ selectedKeys, onItemSelectAll, onItemSelect }) => {
      return {
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .filter(item => !item.disabled)
            .map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      };
    };

    const pagination = computed(() => ({
      total: total.value,
      current: current.value,
      pageSize: 10,
    }))
    const search=async(d,value)=>{
      mockData.value=[]
      getList({keyword:value,limit:10,page:current.value})
    }
    const handleTableChange = (pag, filters, sorter) => {
      current.value=pag?.current
      search('','')
    };
    const filterHandle=(inputValue, item) => { 
      return item
    }
    return {
      pagination,
      mockData,
      targetKeys,
      disabled,
      search,
      showSearch,
      leftColumns,
      rightColumns,
      onChange,
      getRowSelection,
      handleTableChange,
      filterHandle
    };
  },
});
</script>